import React, { createContext, useContext, useState } from 'react';

const BlurContext = createContext();

export const useBlur = () => {
  const context = useContext(BlurContext);
  if (!context) {
    throw new Error('useBlur must be used within a BlurProvider');
  }
  return context;
};

// Safe hook that doesn't throw if context is not available
export const useBlurSafe = () => {
  const context = useContext(BlurContext);
  if (!context) {
    return {
      isBlurred: false,
      setIsBlurred: () => {},
    };
  }
  return context;
};

export const BlurProvider = ({ children }) => {
  const [isBlurred, setIsBlurred] = useState(false);

  const value = {
    isBlurred,
    setIsBlurred,
  };

  return (
    <BlurContext.Provider value={value}>
      {children}
    </BlurContext.Provider>
  );
};